import React from "react";

/* Replace with your actual images */
import aboutHero from "../assets/img/menu-1.webp";
import aboutCampus from "../assets/img/about/about-campus.png";
import aboutStudents from "../assets/img/menu-2.png";
import campusImage from "../assets/img/about/campus-life.png";
import MetaInfo from "../components/MetaInfo";
import Footer from "../components/Footer";
import Header from "../components/Header";

const aboutStats = [
    { value: "13", label: "Academic Schools" },
    { value: "02", label: "Campus Experiences" },
    { value: "UG–PhD", label: "Academic Pathways" },
    { value: "01", label: "Student-Centred University" },
];

const values = [
    {
        title: "Academic Excellence",
        text: "A learning environment designed to encourage knowledge, intellectual curiosity and continuous academic development.",
    },
    {
        title: "Practical Learning",
        text: "Opportunities to connect academic concepts with projects, practical activities and application-oriented learning.",
    },
    {
        title: "Future Readiness",
        text: "Education that supports the development of professional capabilities for evolving careers and industries.",
    },
    {
        title: "Inclusive Growth",
        text: "A university environment where learners from diverse backgrounds can pursue their academic aspirations.",
    },
];

const academicAreas = [
    "Science",
    "Arts & Humanities",
    "Law",
    "Pharmacy",
    "Design",
    "Education",
    "Journalism & Mass Communication",
    "Media & Entertainment",
    "Library & Information Science",
    "Yoga & Naturopathy",
    "Life Science",
    "Vocational Management",
    "Health & Allied Science",
];

const learningApproach = [
    {
        number: "01",
        title: "Learn",
        text: "Build strong academic foundations through structured teaching and disciplinary knowledge.",
    },
    {
        number: "02",
        title: "Apply",
        text: "Connect concepts with practical activities, projects, laboratories and experiential learning.",
    },
    {
        number: "03",
        title: "Explore",
        text: "Develop curiosity through research, discussion, interdisciplinary exposure and independent learning.",
    },
    {
        number: "04",
        title: "Progress",
        text: "Develop capabilities that support higher education, professional growth and lifelong learning.",
    },
];

export default function AboutUs() {
    return (
        <>
            <MetaInfo param="" id="about" />

            <Header school="common" />

            <main className="overflow-hidden bg-white">

                {/* 01. HERO */}
                <section className="relative min-h-[60vh] overflow-hidden bg-[#071A2F] text-white lg:min-h-[60vh]">

                    <img src={aboutHero} alt="ISBM University campus" className="absolute inset-0 h-full w-full object-cover" />

                    <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F] via-[#071A2F]/90 to-[#071A2F]/20" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 via-transparent to-[#071A2F]/20" />

                    <div className="relative mx-auto flex min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-end pb-20 pt-[190px] max-sm:w-[calc(100%-28px)] lg:min-h-[60vh] lg:pb-24">

                        <div className="max-w-[900px]">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                About ISBM University
                            </div>

                            <h1 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(50px,6.5vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">
                                An environment where
                                <span className="block text-[#D5AD57]">
                                    learning moves forward.
                                </span>
                            </h1>

                            <p className="mt-8 max-w-[690px] text-[17px] leading-8 text-white/70">
                                ISBM University brings together multidisciplinary education,
                                practical learning and student development to help learners
                                prepare for a changing world.
                            </p>

                            <div className="mt-10 flex flex-wrap gap-4">

                                <a
                                    href="/programmes"
                                    className="group inline-flex min-h-[56px] items-center gap-10 bg-[#D5AD57] px-7 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]"
                                >
                                    Explore Programmes
                                    <span className="transition-transform group-hover:translate-x-1">
                                        →
                                    </span>
                                </a>

                                <a
                                    href="/admissions"
                                    className="inline-flex min-h-[56px] items-center gap-8 border border-white/30 px-7 text-sm font-bold uppercase tracking-[0.1em] text-white transition hover:border-white"
                                >
                                    Admissions
                                    <span>↗</span>
                                </a>

                            </div>
                        </div>
                    </div>

                    {/* bottom descriptor */}

                    <div className="absolute bottom-0 right-0 hidden border-l border-t border-white/15 bg-[#071A2F]/80 backdrop-blur-md lg:block">
                        <div className="flex items-center gap-8 px-9 py-6">
                            <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                Discover ISBM
                            </span>

                            <span className="h-8 w-px bg-white/20" />

                            <span className="text-sm text-white/60">
                                Academics · Campus · Community
                            </span>
                        </div>
                    </div>

                </section>

                {/* 02. UNIVERSITY STORY */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-24">

                            {/* IMAGE COMPOSITION */}

                            <div className="relative min-h-[560px] sm:min-h-[650px]">

                                <figure className="absolute left-0 top-0 h-[78%] w-[78%] overflow-hidden">
                                    <img
                                        src={aboutCampus}
                                        alt="ISBM University academic environment"
                                        className="h-full w-full object-cover"
                                    />
                                </figure>

                                <figure className="absolute bottom-0 right-0 h-[46%] w-[48%] overflow-hidden border-[10px] border-white">
                                    <img
                                        src={aboutStudents}
                                        alt="Students at ISBM University"
                                        className="h-full w-full object-cover"
                                    />
                                </figure>

                                <div className="absolute bottom-[13%] left-[6%] bg-[#8B1E3F] px-7 py-6 text-white">
                                    <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        University
                                    </span>

                                    <strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-[27px] font-normal">
                                        Learn. Discover. Grow.
                                    </strong>
                                </div>

                            </div>

                            {/* CONTENT */}

                            <div>

                                <div className="flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                    <span className="h-px w-10 bg-current" />
                                    Our University
                                </div>

                                <h2 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,4.7vw,66px)] font-normal leading-[1.04] tracking-[-0.04em] text-[#071A2F]">
                                    Education built around
                                    <em className="block font-normal text-[#8B1E3F]">
                                        possibility.
                                    </em>
                                </h2>

                                <p className="mt-8 text-[18px] leading-8 text-[#071A2F]">
                                    ISBM University is a multidisciplinary higher-education
                                    institution committed to creating meaningful learning
                                    opportunities for students.
                                </p>

                                <p className="mt-5 text-[15px] leading-8 text-[#66727D]">
                                    Through academic programmes spanning diverse disciplines, the
                                    University seeks to combine classroom learning with practical
                                    exposure, research, skill development and opportunities for
                                    personal and professional growth.
                                </p>

                                <p className="mt-5 text-[15px] leading-8 text-[#66727D]">
                                    The University experience is designed to encourage students to
                                    question, explore, collaborate and develop the confidence to
                                    navigate opportunities beyond the classroom.
                                </p>

                                <div className="mt-10 border-l-[3px] border-[#D5AD57] pl-7">
                                    <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[26px] leading-[1.45] text-[#071A2F]">
                                        A university should not simply prepare students for their
                                        next examination —
                                        <span className="text-[#8B1E3F]">
                                            {" "}it should prepare them for what comes next.
                                        </span>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* 03. AT A GLANCE */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_auto] lg:items-end">

                            <div>
                                <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                    ISBM at a Glance
                                </span>

                                <h2 className="mt-5 max-w-[720px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(38px,4vw,58px)] font-normal leading-[1.08] text-[#071A2F]">
                                    One university.
                                    <span className="text-[#8B1E3F]">
                                        {" "}Many ways to learn.
                                    </span>
                                </h2>
                            </div>

                            <p className="max-w-[420px] text-sm leading-7 text-[#68747F]">
                                A multidisciplinary academic ecosystem designed around different
                                interests, ambitions and educational pathways.
                            </p>

                        </div>

                        <div className="grid sm:grid-cols-2 lg:grid-cols-4">

                            {aboutStats.map((item, index) => (
                                <article
                                    key={item.label}
                                    className={`py-10 lg:px-9 ${index !== 0 ? "lg:border-l lg:border-[#071A2F]/15" : ""
                                        }`}
                                >
                                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(48px,5vw,70px)] font-normal leading-none text-[#8B1E3F]">
                                        {item.value}
                                    </strong>

                                    <span className="mt-4 block text-sm font-bold uppercase tracking-[0.12em] text-[#071A2F]">
                                        {item.label}
                                    </span>
                                </article>
                            ))}

                        </div>
                    </div>
                </section>

                {/* 04. VISION + MISSION */}
                <section className="bg-[#8B1E3F] text-white">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid lg:grid-cols-2">

                            {/* VISION */}

                            <article className="border-white/15 py-20 lg:border-r lg:py-24 lg:pr-16">

                                <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                    01 / Our Vision
                                </span>

                                <h2 className="mt-8 max-w-[560px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,4vw,60px)] font-normal leading-[1.08]">
                                    Looking beyond today&apos;s classroom.
                                </h2>

                                <p className="mt-8 max-w-[560px] text-[16px] leading-8 text-white/65">
                                    Build this area around ISBM University&apos;s official vision
                                    statement, expressing the long-term educational impact the
                                    University seeks to create.
                                </p>

                                <span className="mt-14 block text-[50px] text-[#D5AD57]">
                                    ↗
                                </span>

                            </article>

                            {/* MISSION */}

                            <article className="py-20 lg:py-24 lg:pl-16">

                                <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                    02 / Our Mission
                                </span>

                                <h2 className="mt-8 max-w-[560px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,4vw,60px)] font-normal leading-[1.08]">
                                    Turning educational purpose into action.
                                </h2>

                                <p className="mt-8 max-w-[560px] text-[16px] leading-8 text-white/65">
                                    Insert the University&apos;s approved mission statement here,
                                    supported by the principles that guide teaching, learning,
                                    research and student development.
                                </p>

                                <span className="mt-14 block text-[50px] text-[#D5AD57]">
                                    →
                                </span>

                            </article>

                        </div>
                    </div>
                </section>

                {/* 05. WHAT DEFINES US */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="max-w-[760px]">

                            <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                What Defines ISBM
                            </span>

                            <h2 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,4.8vw,66px)] font-normal leading-[1.04] text-[#071A2F]">
                                Principles that shape the
                                <span className="text-[#8B1E3F]"> university experience.</span>
                            </h2>

                        </div>

                        <div className="mt-14 border-t border-[#071A2F]/15">

                            {values.map((item, index) => (
                                <article
                                    key={item.title}
                                    className="group grid gap-5 border-b border-[#071A2F]/15 py-8 sm:grid-cols-[100px_.8fr_1.2fr_50px] sm:items-center"
                                >
                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#8B1E3F]">
                                        0{index + 1}
                                    </span>

                                    <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[27px] font-normal text-[#071A2F]">
                                        {item.title}
                                    </h3>

                                    <p className="max-w-[540px] text-sm leading-7 text-[#68747E]">
                                        {item.text}
                                    </p>

                                    <span className="text-xl text-[#8B1E3F] transition-transform group-hover:translate-x-1">
                                        →
                                    </span>
                                </article>
                            ))}

                        </div>
                    </div>
                </section>

                {/* 06. ACADEMIC ECOSYSTEM */}
                <section className="bg-[#EEF4F8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[370px_1fr] lg:gap-20">

                            <div>
                                <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                    Multidisciplinary University
                                </span>

                                <h2 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,4vw,58px)] font-normal leading-[1.06] text-[#071A2F]">
                                    Explore our academic
                                    <span className="block text-[#8B1E3F]">ecosystem.</span>
                                </h2>

                                <p className="mt-6 text-[15px] leading-8 text-[#687580]">
                                    Academic schools bring together different disciplines while
                                    giving students opportunities to pursue programmes aligned
                                    with their interests and goals.
                                </p>

                                <a
                                    href="/schools"
                                    className="mt-8 inline-flex items-center gap-7 text-sm font-bold uppercase tracking-[0.1em] text-[#8B1E3F]"
                                >
                                    Explore All Schools →
                                </a>
                            </div>

                            <div className="border-t border-[#071A2F]/15">

                                {academicAreas.map((area, index) => (
                                    <a
                                        key={area}
                                        href="/schools"
                                        className="group grid grid-cols-[50px_1fr_40px] items-center border-b border-[#071A2F]/15 py-5"
                                    >
                                        <span className="text-xs font-bold text-[#8B1E3F]/50">
                                            {String(index + 1).padStart(2, "0")}
                                        </span>

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[21px] text-[#071A2F] transition-colors group-hover:text-[#8B1E3F] sm:text-[24px]">
                                            {area}
                                        </span>

                                        <span className="text-[#8B1E3F] transition-transform group-hover:translate-x-1">
                                            ↗
                                        </span>
                                    </a>
                                ))}

                            </div>
                        </div>
                    </div>
                </section>

                {/* 07. CAMPUS */}
                <section className="relative min-h-[700px] overflow-hidden bg-[#071A2F] text-white">

                    <img
                        src={campusImage}
                        alt="ISBM University campus experience"
                        className="absolute inset-0 h-full w-full object-cover"
                    />

                    <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F]/95 via-[#071A2F]/75 to-[#071A2F]/20" />

                    <div className="relative mx-auto flex min-h-[700px] w-[min(1380px,calc(100%-48px))] items-center py-20 max-sm:w-[calc(100%-28px)]">

                        <div className="max-w-[650px]">

                            <span className="text-sm font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
                                Life Beyond the Classroom
                            </span>

                            <h2 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(44px,5vw,70px)] font-normal leading-[1.02]">
                                A campus built for
                                <span className="block text-[#D5AD57]">
                                    learning and belonging.
                                </span>
                            </h2>

                            <p className="mt-7 max-w-[580px] text-base leading-8 text-white/65">
                                University life extends beyond lectures. Academic spaces,
                                student activities, collaboration, recreation and community
                                experiences contribute to a more complete learning journey.
                            </p>

                            <div className="mt-9 flex flex-wrap gap-4">

                                <a
                                    href="/campus-life"
                                    className="bg-[#D5AD57] px-7 py-4 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]"
                                >
                                    Explore Campus Life →
                                </a>

                                <a
                                    href="/contact"
                                    className="border border-white/30 px-7 py-4 text-sm font-bold uppercase tracking-[0.1em]"
                                >
                                    Plan a Visit
                                </a>

                            </div>
                        </div>
                    </div>
                </section>

                {/* 08. LEARNING PHILOSOPHY */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20">

                            <div>
                                <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                    Our Learning Philosophy
                                </span>

                                <h2 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,4vw,58px)] font-normal leading-[1.07] text-[#071A2F]">
                                    Learning designed to
                                    <span className="text-[#8B1E3F]"> move with you.</span>
                                </h2>
                            </div>

                            <div className="grid sm:grid-cols-2">

                                {learningApproach.map((item) => (
                                    <article
                                        key={item.number}
                                        className="border-b border-[#071A2F]/15 p-7 first:border-t sm:border-l sm:first:border-t-0 lg:p-9"
                                    >
                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[30px] text-[#8B1E3F]">
                                            {item.number}
                                        </span>

                                        <h3 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[29px] font-normal text-[#071A2F]">
                                            {item.title}
                                        </h3>

                                        <p className="mt-4 text-sm leading-7 text-[#687580]">
                                            {item.text}
                                        </p>
                                    </article>
                                ))}

                            </div>
                        </div>
                    </div>
                </section>

                {/* 09. STUDENT EXPERIENCE */}
                <section className="bg-[#F4E8EC] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[1.15fr_.85fr] lg:items-center lg:gap-20">

                            <div>
                                <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                    The Student Experience
                                </span>

                                <h2 className="mt-6 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,4.8vw,66px)] font-normal leading-[1.04] text-[#071A2F]">
                                    University is where you study.
                                    <span className="block text-[#8B1E3F]">
                                        And where you grow.
                                    </span>
                                </h2>

                                <p className="mt-7 max-w-[650px] text-base leading-8 text-[#68747E]">
                                    Academic learning is one part of the university experience.
                                    Collaboration, activities, friendships, challenges and new
                                    responsibilities also help students develop personally.
                                </p>
                            </div>

                            <div className="border-l-2 border-[#8B1E3F] pl-8 sm:pl-10">

                                {[
                                    "Student activities & engagement",
                                    "Sports & recreation",
                                    "Cultural experiences",
                                    "Academic collaboration",
                                    "Innovation & creativity",
                                    "Personal development",
                                ].map((item) => (
                                    <div
                                        key={item}
                                        className="flex items-center gap-5 border-b border-[#071A2F]/10 py-4"
                                    >
                                        <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]" />

                                        <span className="text-[15px] font-semibold text-[#071A2F]">
                                            {item}
                                        </span>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </section>

                {/* 10. INSTITUTIONAL INFORMATION */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">

                            <div>
                                <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                    Institutional Information
                                </span>

                                <h2 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(38px,4vw,56px)] font-normal leading-[1.08] text-[#071A2F]">
                                    Know the university
                                    <span className="text-[#8B1E3F]"> with confidence.</span>
                                </h2>

                                <p className="mt-6 max-w-[420px] text-sm leading-7 text-[#68747E]">
                                    Keep regulatory, accreditation, recognition and institutional
                                    information transparent and easy for prospective students to
                                    access.
                                </p>
                            </div>

                            <div className="border-t border-[#071A2F]/15">

                                {[
                                    "University Recognition & Approvals",
                                    "Accreditation Information",
                                    "Statutory Disclosures",
                                    "University Authorities",
                                    "Policies & Regulations",
                                    "Mandatory Disclosures",
                                ].map((item) => (
                                    <a
                                        href="#"
                                        key={item}
                                        className="group flex items-center justify-between border-b border-[#071A2F]/15 py-6"
                                    >
                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[22px] text-[#071A2F] group-hover:text-[#8B1E3F]">
                                            {item}
                                        </span>

                                        <span className="text-[#8B1E3F] transition-transform group-hover:translate-x-1">
                                            ↗
                                        </span>
                                    </a>
                                ))}

                            </div>
                        </div>
                    </div>
                </section>

                {/* 11. FINAL CTA */}
                <section className="relative overflow-hidden bg-[#8B1E3F] py-20 text-white sm:py-24">

                    <span
                        aria-hidden="true"
                        className="pointer-events-none absolute -bottom-16 right-0 font-['Libre_Caslon_Display',Georgia,serif] text-[220px] leading-none text-white/[0.035] sm:text-[340px]"
                    >
                        ISBM
                    </span>

                    <div className="relative mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end">

                            <div>
                                <span className="text-sm font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
                                    Your Journey Can Start Here
                                </span>

                                <h2 className="mt-6 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(44px,5vw,72px)] font-normal leading-[1.02]">
                                    Discover where an ISBM University
                                    <span className="text-[#D5AD57]">
                                        {" "}education could take you.
                                    </span>
                                </h2>
                            </div>

                            <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">

                                <a
                                    href="/programmes"
                                    className="group flex min-h-[58px] min-w-[220px] items-center justify-between bg-[#D5AD57] px-7 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]"
                                >
                                    Find a Programme
                                    <span>→</span>
                                </a>

                                <a
                                    href="/apply"
                                    className="flex min-h-[58px] min-w-[220px] items-center justify-between border border-white/30 px-7 text-sm font-bold uppercase tracking-[0.1em]"
                                >
                                    Apply Now
                                    <span>↗</span>
                                </a>

                            </div>
                        </div>
                    </div>
                </section>

            </main>

            <Footer />
        </>
    );
}